import { acceptHMRUpdate, defineStore } from "pinia";
import { ref } from "vue";


import { Language } from "@/data/model/Enums";



import { changeLanguage, clientLanguage } from "@/shared/localization/language";
import { setSharedTranslationsLanguage } from "@/shared/localization/translations";



import { setAppTranslationsLanguage } from "@/app/localization/Trans";


export const useLanguageStore = defineStore("language", () => {
    const current = ref<Language>(clientLanguage());

    // bumped on every change so views can re-mount and re-read the rebuilt translations
    // const version = ref(0);

    function setLanguage(language: Language) {
        if (language === current.value) return;

        changeLanguage(language);
        setSharedTranslationsLanguage(language);
        setAppTranslationsLanguage(language);

        current.value = language;
    }

    function resetLanguage() {
        changeLanguage(undefined);
        setSharedTranslationsLanguage(clientLanguage());
        setAppTranslationsLanguage(clientLanguage());

        current.value = clientLanguage();
    }

    return {
        current,
        resetLanguage,
        setLanguage,
    };
});

export type LanguageStore = ReturnType<typeof useLanguageStore>;

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useLanguageStore, import.meta.hot));
}
